import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetsRowComponent } from './widgets-row/widgets-row.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { WidgetsColumnComponent } from './widgets-column/widgets-column.component';
import { WidgetsFieldComponent } from './widgets-field/widgets-field.component';
import { WidgetsTextComponent } from './widgets-text/widgets-text.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatBadgeModule } from '@angular/material/badge';
import { WidgetsFormComponent } from './widgets-form/widgets-form.component';
import { MatIconModule } from '@angular/material/icon';
import { WidgetsArrayComponent } from './widgets-array/widgets-array.component';
import { WidgetsQuestionComponent } from './widgets-question/widgets-question.component';
import { ValdnWidgetsDateComponent } from '../valdn-widgets/valdn-widgets-date/valdn-widgets-date.component';
import { ValdnWidgetsComparisonComponent } from '../valdn-widgets/valdn-widgets-comparison/valdn-widgets-comparison.component';
import { ValdnWidgetsIPComponent } from '../valdn-widgets/valdn-widgets-ip/valdn-widgets-ip.component';
import { LoggerFactory } from 'src/app/core/logger-factory';
import { Logger } from 'src/app/core/logger';
import { WidgetsSectionComponent } from './widgets-section/widgets-section.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { MetadataContainerComponent } from './metadata-container/metadata-container.component';
import { MetadataQuestionComponent } from './metadata-question/metadata-question.component';
import { MetadataSectionComponent } from './metadata-section/metadata-section.component';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';
import { WidgetsRadioComponent } from './widgets-radio/widgets-radio.component';
import { MetadataRadioComponent } from './metadata-radio/metadata-radio.component';
import { MetadataWidgetComponent } from './metadata-widget/metadata-widget.component';
import { MetadataFormComponent } from './metadata-form/metadata-form.component';
import { MatSelectModule } from '@angular/material/select';
import { MatMenuModule } from '@angular/material/menu';
import { MetadataFieldComponent } from './metadata-field/metadata-field.component';
import { MetadataBuiltinFieldComponent } from './metadata-builtin-field/metadata-builtin-field.component';
import { MetadataCheckboxComponent } from './metadata-checkbox/metadata-checkbox.component';
import { WidgetsCheckboxComponent} from './widgets-checkbox/widgets-checkbox.component';
import { WidgetsInputComponent } from './widgets-input/widgets-input.component';
import { MetadataInputComponent } from './metadata-input/metadata-input.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { WidgetsLibraryItemComponent } from './widgets-library-item/widgets-library-item.component';
import { WidgetsTimeRangeComponent } from './widgets-time-range/widgets-timerange.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { StatusComponent } from './status/status.component';
import { MetadataQuestionApiComponent } from './metadata-question-api/metadata-question-api.component';
import { MetadataTimeRangeComponent } from './metadata-timeRange/metadata-timerange.component';
import { WidgetRelatedInputComponent } from './widget-related-input/widget-related-input.component';
import { MetadataRelatedInputComponent } from './metadata-related-input/metadata-related-input.component'; 
import { RouterModule } from '@angular/router';
import { MetadataTemplateComponent } from './metadata-template/metadata-template.component';
import { MatCheckboxModule } from '@angular/material/checkbox';


@NgModule({
    declarations: [
        WidgetsRowComponent,
        WidgetsColumnComponent,
        WidgetsFieldComponent,
        WidgetsTextComponent,
        WidgetsFormComponent,
        WidgetsArrayComponent,
        WidgetsQuestionComponent,
        WidgetsSectionComponent,
        WidgetsRadioComponent,
        WidgetsTimeRangeComponent,
        ValdnWidgetsDateComponent,
        ValdnWidgetsComparisonComponent,
        ValdnWidgetsIPComponent,
        MetadataContainerComponent,
        MetadataFormComponent,
        MetadataQuestionComponent,
        MetadataQuestionApiComponent,
        MetadataSectionComponent,
        MetadataRadioComponent,
        MetadataBuiltinFieldComponent,
        MetadataTimeRangeComponent,
        MetadataWidgetComponent,
        MetadataFieldComponent,
        WidgetsCheckboxComponent,
        MetadataCheckboxComponent,
        WidgetsInputComponent,
        MetadataInputComponent,
        WidgetsLibraryItemComponent,
        StatusComponent,
        WidgetRelatedInputComponent,
        MetadataRelatedInputComponent,
        MetadataTemplateComponent
    ],
    exports: [
        WidgetsRowComponent,
        WidgetsColumnComponent,
        WidgetsFieldComponent,
        WidgetsTextComponent,
        WidgetsFormComponent,
        WidgetsArrayComponent,
        WidgetsQuestionComponent,
        WidgetsSectionComponent,
        WidgetsRadioComponent,
        WidgetsTimeRangeComponent,
        MetadataBuiltinFieldComponent,
        WidgetsInputComponent,
        ValdnWidgetsDateComponent,
        ValdnWidgetsComparisonComponent,
        ValdnWidgetsIPComponent,
        MetadataContainerComponent,
        MetadataFormComponent,
        MetadataQuestionComponent,
        MetadataQuestionApiComponent,
        MetadataWidgetComponent,
        WidgetsLibraryItemComponent,
        MetadataFieldComponent,
        WidgetRelatedInputComponent,
        StatusComponent,
        MetadataTemplateComponent
        
    ],
    providers: [{ provide: Logger, useFactory: LoggerFactory }],
    imports: [
        CommonModule,
        DragDropModule,
        FlexLayoutModule,
        FormsModule,
        MatInputModule,
        MatBadgeModule,
        MatIconModule,
        MatSelectModule,
        MatListModule,
        MatDividerModule,
        MatMenuModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        SharedModule,
        MatRadioModule,
        NgxMatSelectSearchModule,
        MatFormFieldModule,
        MatAutocompleteModule,
        RouterModule,
        MatCheckboxModule    
    ]
})
export class WidgetsModule {
}
